import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import { fetchUploadAll, deleteFileUpload, pushUpload, proccessUpload } from "../../api/fileupload";
import FileUploadList from "../../granular/FileUpload/fileupload";
import MenuItem from '@material-ui/core/MenuItem';
import moment from "moment";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class FileUploads extends Component{

  constructor(props) {
    super(props);
    this.state = {
      datatable: [],
      openAdd: false,
      openEdit: false,
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: localStorage.getItem("company_code"),
      user_id: localStorage.getItem("id"),
      loader: null
    };
  }

  UNSAFE_componentWillMount() {
    console.log(localStorage);
  }

    componentDidMount(){
        this.getDatatable()
    }

    handleDelete = (id) => {
        deleteFileUpload(id)
            .then(response => {
            if (response != null) {
                this.getDatatable();
            }
        })
        .catch(error => {
            console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
        });
        console.log(id);
    }

    handleClose = (key,value) =>{
        this.setState({
          [key]: value
        })
    }

    getDatatable = () => {
        this.props.pushLoader(true)
        this.setState({loader: true})
        fetchUploadAll()
        .then(response => {
            if (response != null) {

                this.setState({ datatable: response.data.results });
            }
            this.props.pushLoader(false)
            this.setState({loader: false})
        })
        .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
        });
    }

    handleSubmit = () => {
        pushUpload(this.state)
        .then(response => {
            if (response != null) {
                this.setState({
                    description: "-",
                    openAdd: false
                })
                this.getDatatable();
            }
        })
        .catch(error => {
            this.props.history.push("/pages/login#logout");
        })
    }

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    //console.log(event.target.files[0].name);

    const ext = event.target.files[0].name.split(".");

    proccessUpload(event.target.files[0], ext[1])
      .then(response => {
        this.setState({ urlfile: response.data.url })
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

    handleChangeText = () => {

    }

    render(){
        return(

            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <Button color="primary" onClick={() => this.handleClose("openAdd", true)}>
                                Add File
                            </Button>
                        </CardHeader>
                        <FileUploadList
                            datatable={this.state.datatable}
                            handleDelete={this.handleDelete}
                            loader={this.state.loader}
                        />
                    </Card>
                    <Dialog fullScreen open={this.state.openAdd} onClose={() => this.handleClose("openAdd", false)} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Add File</DialogTitle>
                        <DialogContent>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput
                                        labelText="Description"
                                        id="headerText"

                                        inputProps={{
                                            value: this.state.description,
                                            onChange: e => { this.setState({description: e.target.value}) }
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                  <Button variant="contained" component="label">
                                    <CustomInput
                                      inputProps={{
                                        type: "file",
                                        onChange: this.handleFileUpload
                                      }}
                                    />
                                  </Button>
                                </GridItem>

                            </GridContainer>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleClose("openAdd", false)} color="default">
                                Cancel
                            </Button>
                            <Button onClick={() => this.handleSubmit()}  color="primary">
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>
                </GridItem>
            </GridContainer>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default withRouter(connect(mapStateToProps, {pushLoader})(FileUploads));
